import { useRef, useState } from 'react';
import { useEventListener } from 'usehooks-ts';

const useInactivityCheck = () => {
  const [inactivity, setInactivity] = useState<boolean>(false);
  const documentRef = useRef<Document>(document);
  const streamStopTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      streamStopTimeoutRef.current = setTimeout(() => {
        setInactivity(true);
      }, 5 * 60 * 1000); // 5 minutes
    } else {
      if (streamStopTimeoutRef.current) {
        clearTimeout(streamStopTimeoutRef.current);
      }
      setInactivity(false);
    }
  };

  useEventListener('visibilitychange', onVisibilityChange, documentRef);
  return inactivity;
};

export default useInactivityCheck;
